import { render, staticRenderFns } from "./PartnerPrivacyIndia.vue?vue&type=template&id=ee40b46a&scoped=true"
import script from "./PartnerPrivacyIndia.vue?vue&type=script&lang=js"
export * from "./PartnerPrivacyIndia.vue?vue&type=script&lang=js"
import style0 from "./PartnerPrivacyIndia.vue?vue&type=style&index=0&id=ee40b46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee40b46a",
  null
  
)

export default component.exports